import React from 'react';

export const BaseContainer = (props) => {
    return (
        <div style={{ height: props.height }} className={`${props.className} ${props.container && "container my-2"}`}>
            {props.children}
        </div>
    );
}